'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'binary';
var width = 384;
var height = 512;
var aliases = [];
var unicode = 'e33b';
var svgPathData = 'M240 0l64 0 16 0 0 16 0 176 48 0 16 0 0 32-16 0-64 0-64 0-16 0 0-32 16 0 48 0 0-160-48 0-16 0 0-32 16 0zM16 288l64 0 16 0 0 16 0 176 48 0 16 0 0 32-16 0-64 0-64 0L0 512l0-32 16 0 48 0 0-160-48 0L0 320l0-32 16 0zM0 0L16 0 176 0l16 0 0 16 0 192 0 16-16 0L16 224 0 224l0-16L0 16 0 0zM32 32l0 160 128 0 0-160L32 32zM208 288l160 0 16 0 0 16 0 192 0 16-16 0-160 0-16 0 0-16 0-192 0-16 16 0zm16 192l128 0 0-160-128 0 0 160z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBinary = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;